import React from 'react';
import * as styles from './NotificationDot.module.scss';

const NotificationDot = () => {
  return <div className={styles.dot} />;
};

export default NotificationDot;
